// extracted by mini-css-extract-plugin
export default {"heading":"OurValues_heading__71-6d","cont":"OurValues_cont__ZMFrt","maincontainer":"OurValues_maincontainer__SPzXc","sectionvaluesmain":"OurValues_sectionvaluesmain__oohMN"};